export default __webpack_public_path__ + "static/media/ART6.13cd1543.jpg";